export const BRAND_DATA: {
  [K: string]: {
    reviews?: ReviewType[]
    videoId?: string
  }
} = {
  'cobra-puma-golf': {
    videoId: 'Rb1GobDarKQ',
    reviews: [
      {
        reviewer: {
          name: 'GOLF DIGEST',
          description: 'LTDx/LTDx ONE železá',
        },
        content:
          'Začnime vzhľadom. Preč sú karbónové pásiky, ktoré boli na železách Cobra z nedávnej minulosti, a hranatý tvar bol nahradený zaoblenejšou špičkou. Obe si určite obľúbia golfisti, ktorí túžia po konvenčnejšom vzhľade. Kovaná geometria cupface bola inšpirovaná zameraním sa na údaje o vzore zásahov, ktoré spoločnosť zhromaždila na identifikáciu najbežnejších miest s nesprávnym zásahom, a následne na zrýchlenie v týchto oblastiach.',
      },
      {
        reviewer: {
          name: 'GOLF DIGEST',
          description: 'Aerojet hybridy',
        },
        content:
          'Vnútorné váženie v hybride je problém. Keď je hmota tlačená dopredu, aby sa znížilo ťažisko, hrubšia podrážka môže obmedziť spôsob ohýbania tváre. Cobra tento problém prekonáva vnútornou mostíkovou štruktúrou, ktorá je mierne vyvýšená nad tvárovou vložkou, ktorá obopína podrážku. Mostík váži 43 gramov s extra závažím na päte a špičke. Tento druh ťažkého nánosu hmoty znižuje ťažisko a zvyšuje stabilitu pri úderoch mimo stredu. Ešte zaujímavejšie: Nápad, známy ako da Vinciho most, prišiel od chlapíka menom Leonardo v roku 1500, ktorý zjavne vedel skákať.',
      },
      {
        reviewer: {
          name: 'Gary Woodland',
          description: 'profesionálny golfista PGA Tour, Cobra staff hráč od januára 2023',
        },
        content:
          'Ich technológia a inovácie sú vynikajúce a som obzvlášť nadšený, že môžem zapojiť ich nový driver dosvojej hry. Všetko čo som trafil bolo presne tak rýchle a dlhé ako si predstavujem a ten dizajn vyzerá super.',
      },
      {
        reviewer: {
          name: 'Jason Dufner',
          description: 'Cobra staff hráč na PGA Tour, reakcia na LTDx Driver',
        },
        content:
          'Jedna vec, ktorú som videl, je, že údery boli skutočne konzistentné v strede hlavy. Loptička letí o niečo vyššie a o niečo viac sa točí, čo je presne to, čo potrebujem. Chcem mať určitú úroveň loftu, aby som mohol získať väčšiu rýchlosť lopty. Čím viac loftu máte, tým nižšiu rýchlosť lopty budete mať, pretože to nie je tak plochý povrch. Takže by som mal vidieť nejaké zvýšenie rýchlosti... zatiaľ sa mi to páči. Je to skvelý pocit. Práve som odohral 9 jamiek a neminul som ani jednu fairway.',
        source: {
          name: 'golfwrx.com',
          link: 'https://www.golfwrx.com/667834/jason-dufner-speaks-on-unreleased-cobra-ltdx-driver-and-his-nearly-decade-old-7-wood/',
        },
      },
      {
        reviewer: {
          name: 'Rickie Fowler',
          description: 'Cobra staff hráč na PGA Tour, reakcia na Aerojet LS Fairwayové drevo',
        },
        content:
          'Samozrejme, že je to vždy niečo, čo sa snažíme dostať do nového produktu, ale bol som spokojný s tým, čo som mal. Hral som minuloročný driver a trojku drevo spred pár rokov, ale cítil som, že nová 3-drevo bola trochu zhovievavejšia. ... Pri Aerojet 3-dreve mám pocit, že je trochu stabilnejšia, ale má veľmi podobné letové vlastnosti, len trochu viac odpúšťa, takže to bol príjemný bonus.',
      },
    ],
  },
  clicgear: {
    videoId: 'pJXxE9gnMSA',
    reviews: [
      {
        content:
          'Všetko je pevné a funkčné. Funkcie fungujú dobre a dizajn je vynikajúci. K dispozícii je viac príslušenstva, takže možnosti sú nekonečné. Jednoduché stláčanie, otváranie a skladanie. Ľahko sa zmestí do kufra.',
      },
      {
        content:
          'Naučiť sa ovládať tento vozík nejaký čas trvá. Videá na YouTube veľmi pomáhajú, ale musíte si ich pozrieť niekoľkokrát. Akonáhle sa ho naučíte ovládať, budete naozaj spokojní, ako sa pohybuje a ovláda váš golfový bag.',
      },
      {
        content:
          'Tento vozík absolútne milujem! Predtým som nemal inú značku, takže som sa pustil do toho a išiel som s tými najlepšími. Ľahko sa rozloží a zloží a pri skladovaní je skutočne malý (výška 24 palcov). Na ihrisku sa pohybuje hladko, pretože ložiská kolies sú špičkovej kvality. Niekedy, keď kráčam po fairwayi, mierne naň zatlačím a mám pocit, že ide sám. K dispozícii je malý krytý úložný priestor na uloženie mobilného telefónu, ďalších loptičiek, teečiek a výsledková karta sa zmestí na vrch s gumeným remienkom na uchytenie a uloženie ceruzky. Pod priehradkou je sieťované vrecko, do ktorého som vložil svoj diaľkomer. Dodáva sa s držiakom na dáždnik a držiakom na nápoje. Ručná brzda je plus.',
      },
      {
        content: 'Ľahko sa tlačí, ľahko sa používa... je vynikajúci!',
      },
    ],
  },
  rovic: {
    videoId: 'sDdlJvBunkM',
    reviews: [
      {
        content:
          'Tento vozík používam už niekoľko mesiacov a veľmi sa mi páči. Pokazil sa mi diel, ale podpora okamžite zareagovala, poslala mi poštou náhradný diel a mohol som ho bez problémov vymeniť. Takže aj napriek problémom som s týmto produktom veľmi spokojný a odporúčam ho.',
      },
      {
        content:
          'S mojím Rovic vozíkom chodím po ihrisku neustále. Funkcia otáčania je skvelá a v ťažkom teréne je ľahké zablokovať predné koleso na mieste. Ak hľadáte vozík na tlačenie, veľmi vám ho odporúčam. Je síce robustnejší, ale je ľahký a super ľahko sa s ním manévruje.',
      },
      {
        content:
          'S vozíkom sa veľmi ľahko manévruje, ŽIADNA montáž! Otvoríte škatuľu a stlačíte dve alebo tri tlačidlá a idete. Veľmi robustný a neprevracia sa, oveľa viac chodím a je to dobrá návratnosť investícií. Hrám dva-trikrát do týždňa a zakaždým beriem vozík so sebou.',
      },
      {
        content:
          'Skvelý, ľahko použiteľný kvalitný vozík na tlačenie. Otočné predné koleso uľahčuje riadenie, ale ak si to želáte, dá sa aj uzamknúť. Tento vozík sa dá ľahko zložiť na kompaktnú veľkosť pre skladovanie a prepravu a trvá to len niekoľko sekúnd. Vďaka tomu je chôdza po ihrisku potešením a nie fuška. Nie je problém pridať vlastnú tašku na vozík a je veľmi stabilný aj na svahoch. Má dostatok úložného priestoru na uloženie ďalších loptičiek, teečiek a dokonca aj môjho diaľkomeru, ktorý sa zmestí do ľahko prístupnej úložnej schránky na rukoväti. Držiak na dáždnik som ešte nepoužil, ale plánujem toto leto a možno zvážim ďalšie príslušenstvo.',
      },
    ],
  },
  lignum: {
    videoId: 'JP6fsd9TBSI',
  },
  volvik: {
    videoId: 'xe0vZlSYTeA',
    reviews: [
      {
        content:
          'Po absolvovaní siedmych kôl golfu som zistil, že lopty Volvik majú výrazne ľahko sledovateľný let a vynikajúco sa lokalizujú na ihrisku, či už ide o rough alebo fairway. Pri odpale tieto lopty od doslova vylietajú a v porovnaní s niektorými drahšími alternatívami sa oveľa ľahšie ovládajú. Myslím si tiež, že matný povrch prispieva k zlepšeniu odozvy lopty (spin) pri úderoch na ihrisku a chipoch. Zdá sa, akoby lopty zostávali na palici o niečo dlhšie počas kompresie, hoci nemám konkrétne údaje, ktoré by to potvrdili, len osobný pocit.',
      },
      {
        content:
          'Zjednodušene povedané, ide o najjednoduchšiu loptičku na pohľad, ktorá znamená zábavu pre každého a naozaj dlho, pretože zostane vo vzduchu dlhšie ako iné golfové loptičky. Pokiaľ ide o mäkkosť, golfová loptička Vivid nie je taká mäkká ako loptičky na úrovni Tour, na dotyk je skôr ako Srixon Z Star, napriek tomu je na putteri celkom mäkká. Vzhľadom na svoju strednú cenovú kategóriu ponúka Volvik Vivid skvelú hodnotu za peniaze a je veľmi jednoduché ju odporučiť, najmä pre hráčom s pomalším švihom.',
        source: {
          name: 'golf-info-guide.com',
          link: 'https://golf-info-guide.com/golf-ball-tests-and-reviews/volvik-vivid-golf-ball-review/',
        },
      },
      {
        content:
          'Golfová loptička Volvik Vivid Matte Finish je odolná a neobmedzuje vzdialenosť. Nie je najjemnejšia a neponúka najviac rotácií pri približovaní/chipových úderoch, avšak za tie peniaze je to naozaj dobrá kúpa pre víkendového golfistu, ktorý potrebuje novú loptičku v taške.',
      },
    ],
  },
  'ghost-golf': {
    videoId: 'SbCQ08KbDtc',
  },
  trilite: {
    reviews: [
      {
        content:
          'Vrelo odporúčam za tu cenu! Skvelý vozík! Nebolo ľahké rozhodnutie odísť z môjho klasického rýchlostného vozíka SM V1, ale dal som šancu modelu Trilite V2 360… Splnil všetky moje očakávania a zákaznícky servis či podpora je fantastická.',
        source: {
          name: 'Trilitegolf.com',
          link: 'https://www.trilitegolf.com/',
        },
      },
      {
        content:
          'Vynikajúci golfový vozík! Čierny rám so zelenými kolesami je určite upgrade z môjho starého vozíka. Milujem ten pocit, kolesá sa na golfovom ihrisku točia super hladko. Má ručnú brzdu, ktorá je oveľa pohodlnejšia ako nožný pedál. K dispozícii je dostatok úložného priestoru na občerstvenie a ďalšie golfové loptičky. Najlepšou vlastnosťou je, že sa zloží do peknej veľkosti kufra, ktorý sa dá ľahko uložiť v aute. Vrelo odporúčam, ak hľadáte klasický vozík na tlačenie, ktorý je skvelej kvality!',
        source: {
          name: 'Trilitegolf.com',
          link: 'https://www.trilitegolf.com/',
        },
      },
      {
        content:
          'Ovládateľnosť a hmotnosť sú na špičkovej úrovni! Včera som prvýkrát použil svoj strieborný Trilite V3 počas môjho včerajšieho kola. Bolo to veľmi kopcovité ihrisko, takže schopnosť manévrovať a otáčať bola kľúčom k úspechu. Obstálo v skúške času s úspechom! Tiež pršalo, takže to, že som mohol držať môj super obrovský dáždnik počas chôdze, bolo veľmi užitočné.',
        source: {
          name: 'Trilitegolf.com',
          link: 'https://www.trilitegolf.com/',
        },
      },
      {
        content:
          'Pri používaní V3 ma zaujalo niekoľko vecí: Úložný priestor pre všetky moje golfové loptičky, odpaliská, občerstvenie, skórkarty, teečka atď. Nastaviteľná výška – ideálny aj pre niekoho s nižšou výškou, pretože môže pohodlne tlačiť vozík bez pocitu, že je rukoväť príliš vysoká. Hmotnosť – bez problémov som vozík vybral z auta a mohol som ho nastaviť sám bez pomoci. Tento vozík by som určite odporučil, ak hľadáte vozík na tlačenie.',
        source: {
          name: 'Trilitegolf.com',
          link: 'https://www.trilitegolf.com/',
        },
      },
    ],
  },
}

export type ReviewType = {
  reviewer?: {
    name: string
    description: string
  }
  content: string
  source?: {
    name: string
    link: string
  }
}
